<a class="overlay-sidebar-header" [class.overlay-sidebar-header-open]="openSide" (click)="closeOverlay()"></a>
<div class="responsive-btn">
  <a (click)="toggleSidebar()">
    <i class="fa fa-bars text-white" aria-hidden="true"></i>
  </a>
</div>
<div class="navbar m-l-auto" id="togglebtn" [class.openSidebar]="openSide">
  <div class="responsive-btn">
    <a (click)="toggleSidebar()">
      <h5>Voltar</h5>
    </a>
  </div>
  @defer(when appMenu) {
  <ul class="main-menu">
    <!-- 1st Level Menu -->
    @for (firstLvlMenu of appMenu; track $index) {
    <li>
      <!-- Sub -->
      @if (firstLvlMenu.attributes.type === 'sub' && firstLvlMenu.attributes.feature === 'internal') {
      <a class="dropdown" (click)="setActive(firstLvlMenu.attributes.title)">
        {{ firstLvlMenu.attributes.title }}
      </a>
      <!-- Link Primeira camada de text do menu -->
      <!-- Internal navigation -->
      }
      @else if (firstLvlMenu.attributes.type === 'link' && firstLvlMenu.attributes.feature === 'internal') {
      <a [routerLink]="['/']" fragment="{{firstLvlMenu.attributes.path}}" routerLinkActive="active">
        {{ firstLvlMenu.attributes.title }}
      </a>
      <!-- External navigation -->
      }
      @else if (firstLvlMenu.attributes.type === 'link' && firstLvlMenu.attributes.feature === 'external') {
      <a [href]="firstLvlMenu.attributes.path" target="_blank">
        {{ firstLvlMenu.attributes.title }}
      </a>
      }
      <!-- 2nd Level Menu -->
      @if (firstLvlMenu.attributes.Children) {
      <ul [class.opensubmenu]="isActive(firstLvlMenu.attributes.title)">
        @for (secondLLvlMenu of firstLvlMenu.attributes.Children; track $index) {
        <li [class.sub-menu]="secondLLvlMenu.Children > 1">
          <!-- Sub child 1 lvl link-->
          @if(secondLLvlMenu.type === 'sub'){
          <a (click)="setChildActive(secondLLvlMenu.attributes.title)">
            {{secondLLvlMenu.title}}
          </a>
          <!-- Internal navigation -->
          }@else if (secondLLvlMenu.type === 'link' && secondLLvlMenu.feature === 'internal') {
          <a [routerLink]="['/']" fragment="{{secondLLvlMenu.path}}" routerLinkActive="active">
            {{secondLLvlMenu.title}}
          </a>
          <!-- External navigation -->
          }@else if (secondLLvlMenu.type === 'link' && secondLLvlMenu.feature === 'external') {
          <a [href]="secondLLvlMenu.path" target="_blank" routerLinkActive="active">
            {{secondLLvlMenu.title}}
          </a>
          }
          <!-- 3nd Level Menu -->
          @if (secondLLvlMenu.children) {
          <ul [class.openSubChildMenu]="ischildActive(secondLLvlMenu.title)">
            @for (thirdLvlMenu of secondLLvlMenu; track $index) {
            <li>
              <!-- Sub -->
              @if (thirdLvlMenu.type ==='sub') {
              <a href="javascript:void(0)" *ngIf="thirdLvlMenu.type === 'sub'">
                {{thirdLvlMenu.title}}
              </a>
              <!-- Link -->
              }@else if (thirdLvlMenu.type === 'link') {
              <a [routerLink]="!thirdLvlMenu.type ? null : [thirdLvlMenu.path]" routerLinkActive="active">
                {{thirdLvlMenu.title}}
              </a>
              }
            </li>
            }
          </ul>
          }
        </li>
        }
      </ul>
      }
    </li>
    }

  </ul>
  }@placeholder {
  <ul class="main-menu">
    <a>
      <ngx-skeleton-loader [appearance]="'line'" count="3" animation="pulse"
        [theme]="{width:'200px', marginLeft:'15px'}"></ngx-skeleton-loader>
    </a>
  </ul>

  }

</div>
